export default __webpack_public_path__ + "static/media/busFront.02c222c7.png";